import apiUrl from "./config/config";
import axios from "axios";

class variableApi
{

  

  //Update a variable
  static async askVirtual(params)
  {

    try
    {

      let response = "";

      if (params.version == "v1")
        response = await axios.post(apiUrl + "virtual/v1", params);
      else
        response = await axios.post(apiUrl + "virtual/v2", params);

      return response.data;

    } catch (err)
    {

      throw new Error(err);

    }

  }

  //Get a Mosaic public session token for the virtual assistant widget
  static async getPublicSession(product)
  {

    try
    {

      const response = await axios.post(apiUrl + "virtual/session", { product });

      return response.data;

    } catch (err)
    {

      throw new Error(err);

    }

  }

}






export default variableApi;